export default __webpack_public_path__ + "static/media/MODE_map.4d2c2c04.svg";